// Mock data for AAKhwaja Investments website

export const companyInfo = {
  name: "AAKHWAJA INVESTMENTS LLC",
  shortName: "AAKhwaja Investments",
  tagline: "Investing in and Operating Essential Businesses",
  logo: "https://customer-assets.emergentagent.com/job_longterm-invest-2/artifacts/a1cls07j_image.png",
  contact: {
    address: "1450 Dallas Dr, Denton TX 76205",
    email: "info@aakhwajainvestments.com",
    phone: "+1 (940) 382-3499"
  }
};

export const navigation = [
  { id: "home", label: "Home" },
  { id: "about", label: "About Us" },
  { id: "approach", label: "Our Approach" },
  { id: "portfolio", label: "Portfolio" },
  { id: "why-us", label: "Why Our Approach" },
  { id: "contact", label: "Contact" }
];

export const heroContent = {
  headline: "Investing in and Operating Essential Businesses",
  subheadline: "We are a privately held investment firm focused on acquiring, operating, and managing real-world businesses with a long-term ownership mindset.",
  ctaPrimary: "View Our Portfolio",
  ctaSecondary: "Contact Us"
};

export const aboutContent = {
  title: "About Us",
  subtitle: "A Disciplined Approach to Business Ownership",
  paragraphs: [
    "AAKhwaja Investments is a privately held investment holding company that acquires, operates, and manages real-world businesses. We are not a broker, financial advisor, or investment advisory firm.",
    "Our philosophy centers on long-term ownership and hands-on operational involvement. We believe in building lasting value through disciplined management, operational excellence, and a commitment to the communities we serve.",
    "We focus on acquiring stable businesses and actively managing them to ensure sustainable performance. Our approach emphasizes patience, integrity, and a deep understanding of the industries in which we operate."
  ]
};

export const approachContent = {
  title: "Our Approach",
  subtitle: "How We Create Long-Term Value",
  pillars: [
    {
      id: 1,
      title: "Business Acquisition",
      description: "We identify and acquire essential businesses with strong fundamentals, stable cash flows, and growth potential. Our focus is on industries we understand deeply.",
      icon: "Building2"
    },
    {
      id: 2,
      title: "Active Operations & Management",
      description: "We take a hands-on approach to managing our portfolio companies, working closely with local teams to drive operational improvements and maintain high standards.",
      icon: "Settings"
    },
    {
      id: 3,
      title: "Performance Optimization",
      description: "Through continuous improvement initiatives, we enhance efficiency, customer experience, and compliance across all operations.",
      icon: "TrendingUp"
    },
    {
      id: 4,
      title: "Long-Term Ownership",
      description: "We are permanent capital partners. Our investment horizon is measured in decades, not quarters, allowing us to make decisions that benefit all stakeholders.",
      icon: "Shield"
    }
  ]
};

export const portfolioContent = {
  title: "Portfolio",
  subtitle: "Our Operating Assets",
  assets: [
    {
      id: 1,
      name: "Raceway",
      industry: "Fuel & Convenience Retail",
      yearAcquired: "2022",
      location: "Texas",
      focus: [
        "Operational efficiency and cost management",
        "Regulatory compliance and safety standards",
        "Customer experience enhancement",
        "Community engagement and service excellence"
      ],
      description: "A strategically located fuel and convenience retail operation serving the local community with quality products and exceptional service."
    }
  ]
};

export const whyUsContent = {
  title: "Why Our Approach",
  subtitle: "The AAKhwaja Difference",
  reasons: [
    {
      id: 1,
      title: "Operator Mindset",
      description: "We don't just invest—we operate. Our team is actively involved in the day-to-day management of our businesses, ensuring alignment between ownership and operations."
    },
    {
      id: 2,
      title: "Real-World Assets",
      description: "We focus on tangible, essential businesses that serve real needs in their communities. Our portfolio consists of operating companies, not financial instruments."
    },
    {
      id: 3,
      title: "Conservative Growth",
      description: "We prioritize sustainable growth over rapid expansion. Our disciplined approach ensures we only pursue opportunities that align with our capabilities and values."
    },
    {
      id: 4,
      title: "Disciplined Execution",
      description: "Every decision is made with careful consideration of long-term implications. We maintain strict operational and financial discipline across all our holdings."
    }
  ]
};

export const contactContent = {
  title: "Contact Us",
  subtitle: "Let's Start a Conversation",
  description: "We welcome inquiries about business opportunities, partnerships, and general questions about AAKhwaja Investments.",
  formFields: [
    { name: "name", label: "Full Name", type: "text", required: true },
    { name: "email", label: "Email Address", type: "email", required: true },
    { name: "phone", label: "Phone Number", type: "tel", required: false },
    { name: "subject", label: "Subject", type: "select", required: true, options: [
      "General Inquiry",
      "Business Opportunity",
      "Partnership Discussion",
      "Other"
    ]},
    { name: "message", label: "Message", type: "textarea", required: true }
  ]
};

export const legalContent = {
  disclaimer: {
    title: "Disclaimer",
    content: "AAKhwaja Investments LLC does not provide investment advisory, brokerage, or financial planning services. The information presented on this website is for general informational purposes only and should not be construed as investment advice or a solicitation to buy or sell any securities. Past performance is not indicative of future results. All investments involve risk, including the possible loss of principal."
  },
  privacy: {
    title: "Privacy Policy",
    content: "AAKhwaja Investments LLC respects your privacy and is committed to protecting your personal information. We collect only the information necessary to respond to your inquiries and do not sell or share your personal data with third parties except as required by law."
  },
  terms: {
    title: "Terms of Use",
    content: "By accessing this website, you agree to these terms of use. The content on this website is provided 'as is' without warranties of any kind. AAKhwaja Investments LLC reserves the right to modify these terms at any time without prior notice."
  }
};
